export default __webpack_public_path__ + "static/media/worker.60ac6c80.svg";